"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GSFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_95)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_95`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 0V8.2386H8.72982L11.9649 10.393V11.9789H10.3789L5.22807 8.54737V11.9789H0.736842V8.54737L-4.41404 11.9789H-6V10.393L-2.76491 8.2386H-6V3.74737H-2.76491L-6 1.59298V0H-4.41404L0.736842 3.43158V0H5.22807V3.43158L10.3789 0H11.9649Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 0H1.85965V4.87018H-6V7.11579H1.85965V11.9789H4.10526V7.11579H11.9649V4.87018H4.10526V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 1.59296V3.74734H8.72986L11.9649 1.59296Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 11.9789V11.207L-1.61404 8.2386H-0.0280704L-5.48772 11.9789H-6ZM-5.48772 0.00701904L-0.0280704 3.74035H-1.61404L-6 0.778949V0.00701904H-5.48772ZM11.9649 0.00701904V0.778949L7.57895 3.74737H5.99298L11.4526 0.00701904H11.9649ZM11.4526 11.9789L5.99298 8.2386H7.57895L11.9649 11.207V11.9789H11.4526Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25.1158 19.4456C26.2397 19.4456 27.1509 18.0789 27.1509 16.393C27.1509 14.707 26.2397 13.3403 25.1158 13.3403C23.9918 13.3403 23.0807 14.707 23.0807 16.393C23.0807 18.0789 23.9918 19.4456 25.1158 19.4456Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.5544 22.9474C23.407 22.9474 24.0982 22.6552 24.0982 22.2947C24.0982 21.9343 23.407 21.6421 22.5544 21.6421C21.7017 21.6421 21.0105 21.9343 21.0105 22.2947C21.0105 22.6552 21.7017 22.9474 22.5544 22.9474Z",
					fill: "#FFCE00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.5439 22.9474C20.3965 22.9474 21.0877 22.6552 21.0877 22.2947C21.0877 21.9343 20.3965 21.6421 19.5439 21.6421C18.6912 21.6421 18 21.9343 18 22.2947C18 22.6552 18.6912 22.9474 19.5439 22.9474Z",
					fill: "#FFCE00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18 13.3403L21.0456 19.4386L24.0982 13.3403H18Z",
					fill: "#39B200"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.9825 19.4456C18.1064 19.4456 19.0176 18.0789 19.0176 16.393C19.0176 14.707 18.1064 13.3403 16.9825 13.3403C15.8585 13.3403 14.9474 14.707 14.9474 16.393C14.9474 18.0789 15.8585 19.4456 16.9825 19.4456Z",
					fill: "#9B9B9B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.0351 12.3228L19.0175 13.3404H23.0807L22.0631 12.3228L23.0807 9.2702C23.0807 9.2702 22.1684 7.23511 21.0456 7.23511C19.9228 7.23511 19.0105 9.2702 19.0105 9.2702L20.0351 12.3228Z",
					fill: "#757575"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.0456 6.73686C22.1695 6.73686 23.0807 5.82572 23.0807 4.70177C23.0807 3.57783 22.1695 2.66669 21.0456 2.66669C19.9216 2.66669 19.0105 3.57783 19.0105 4.70177C19.0105 5.82572 19.9216 6.73686 21.0456 6.73686Z",
					fill: "#C6B56F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.0877 8.25963C22.2116 8.25963 23.1228 7.34849 23.1228 6.22454C23.1228 5.10059 22.2116 4.18945 21.0877 4.18945C19.9638 4.18945 19.0526 5.10059 19.0526 6.22454C19.0526 7.34849 19.9638 8.25963 21.0877 8.25963Z",
					fill: "#A54A00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25.1158 10.2947C26.2397 10.2947 27.1509 9.38358 27.1509 8.25964C27.1509 7.13569 26.2397 6.22455 25.1158 6.22455C23.9918 6.22455 23.0807 7.13569 23.0807 8.25964C23.0807 9.38358 23.9918 10.2947 25.1158 10.2947Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.0141 12.3298C19.138 12.3298 20.0492 11.4187 20.0492 10.2947C20.0492 9.17078 19.138 8.25964 18.0141 8.25964C16.8901 8.25964 15.979 9.17078 15.979 10.2947C15.979 11.4187 16.8901 12.3298 18.0141 12.3298Z",
					fill: "#0049FF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.1614 12.3298C25.2854 12.3298 26.1965 11.4187 26.1965 10.2947C26.1965 9.17078 25.2854 8.25964 24.1614 8.25964C23.0375 8.25964 22.1263 9.17078 22.1263 10.2947C22.1263 11.4187 23.0375 12.3298 24.1614 12.3298Z",
					fill: "#0041F9"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.0877 18.4281C22.2116 18.4281 23.1228 17.5169 23.1228 16.393C23.1228 15.269 22.2116 14.3579 21.0877 14.3579C19.9638 14.3579 19.0526 15.269 19.0526 16.393C19.0526 17.5169 19.9638 18.4281 21.0877 18.4281Z",
					fill: "#F7D71E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.0456 22.3509C22.1695 22.3509 23.0807 21.4397 23.0807 20.3158C23.0807 19.1918 22.1695 18.2807 21.0456 18.2807C19.9216 18.2807 19.0105 19.1918 19.0105 20.3158C19.0105 21.4397 19.9216 22.3509 21.0456 22.3509Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.035 9.52284L21.0526 9.27722L22.0701 9.52284C22.0701 10.0492 21.0526 10.2948 21.0526 10.2948C21.0526 10.2948 20.035 10.0492 20.035 9.52284Z",
					fill: "#7C0B29"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.9825 10.2737C18.1064 10.2737 19.0176 9.36253 19.0176 8.23858C19.0176 7.11463 18.1064 6.20349 16.9825 6.20349C15.8585 6.20349 14.9474 7.11463 14.9474 8.23858C14.9474 9.36253 15.8585 10.2737 16.9825 10.2737Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_95`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GSFlag };
